export default "__VITE_ASSET__CVEvQDQs__"